export enum CognitoPermissions{
    PLATFORM_ADMIN="role_platform_admin",
    TENANT_OWNER="role_tenant_owner",
    TENANT_ADMIN="role_tenant_admin",
    DOCTOR="role_doctor",
    FRONT_DESK="role_front_desk",
    PATIENT="role_patient",
    VISITOR="role_visitor"
}

export enum SMMModule{
    PLATFORM = 'PLATFORM',            // Platform owner related functions
    CORE = 'CORE',                    // Every function in core (normally free)
    MARKETING = 'MARKETING',          // Marketing module allowing clients to create campains for his clients
    CALENDAR = 'CALENDAR',            // Calendar module, allowing appointments and agenda
    MEDICAL = 'MEDICAL',              // Medical documentation and planning
    DOCUMMENTS = 'DOCUMMENTS',        // Document signing flows and surveys.
    BUSINESS_XRAY = 'BUSINESS_XRAY',  // Business xray with financial reports and KPIs
    STERILIZATION = 'STERILIZATION',  // Sterilization module
    MEDIA = 'MEDIA',                  // Multimedia module
    RECALL = 'RECALL',                // Recall module
    FINANCIAL = 'FINANCIAL'                 // Recall module
}

export enum SMMFeatEnum{
    plf_admin = 'plf_admin',
    core_mdl_mgmt = 'core_mdl_mgmt',
    core_admin = 'core_admin',
    core_cl_mgmt = 'core_cl_mgmt',
    core_team_mgmt_r = 'core_team_mgmt_r',
    core_team_mgmt_w = 'core_team_mgmt_w',
    mkting_audienta = 'mkting_audienta',
    mkting_msg_template = 'mkting_msg_template',
    mkting_campanie = 'mkting_campanie',
    cal_own = 'cal_own',
    cal_oth_r = 'cal_oth_r',
    cal_oth_w = 'cal_oth_w',
    med_doc_stoma = 'med_doc_stoma',
    med_plan_stoma = 'med_plan_stoma',
    doc_fill = 'doc_fill',
    doc_trigger = 'doc_trigger',
    bus_xray = 'bus_xray',
    ster = 'ster',
    mid_xray = 'mid_xray',
    mid_picture = 'mid_picture',
    mid_video = 'mid_video',
    mid_bef_aft = 'mid_bef_aft',
    recall_view_clinic = 'recall_view_clinic',
    recall_view_patient = 'recall_view_patient',
    recall_process = 'recall_process',
    financial_view_clinic = 'financial_view_clinic',
    financial_view_patient = 'financial_view_patient',
    financial_process = 'financial_process',
}

export class Permission {
    id: string;
    name: SMMFeatEnum;
    module: SMMModule;
}

export function getPermissionMap(): Map<SMMFeatEnum, Permission> {
    const permissionMap = new Map<SMMFeatEnum, Permission>();

    permissionMap.set(SMMFeatEnum.plf_admin, {id: "000", name: SMMFeatEnum.plf_admin, module: SMMModule.PLATFORM});
    permissionMap.set(SMMFeatEnum.core_mdl_mgmt, {id: "100", name: SMMFeatEnum.core_mdl_mgmt, module: SMMModule.CORE});
    permissionMap.set(SMMFeatEnum.core_admin, {id: "101", name: SMMFeatEnum.core_admin, module: SMMModule.CORE});
    permissionMap.set(SMMFeatEnum.core_cl_mgmt, {id: "102", name: SMMFeatEnum.core_cl_mgmt, module: SMMModule.CORE});
    permissionMap.set(SMMFeatEnum.core_team_mgmt_r, {id: "103", name: SMMFeatEnum.core_team_mgmt_r, module: SMMModule.CORE});
    permissionMap.set(SMMFeatEnum.core_team_mgmt_w, {id: "104", name: SMMFeatEnum.core_team_mgmt_w, module: SMMModule.CORE});
    permissionMap.set(SMMFeatEnum.mkting_audienta, {id: "200", name: SMMFeatEnum.mkting_audienta, module: SMMModule.MARKETING});
    permissionMap.set(SMMFeatEnum.mkting_msg_template, {
        id: "201",
        name: SMMFeatEnum.mkting_msg_template,
        module: SMMModule.MARKETING
    });
    permissionMap.set(SMMFeatEnum.mkting_campanie, {id: "202", name: SMMFeatEnum.mkting_campanie, module: SMMModule.MARKETING});
    permissionMap.set(SMMFeatEnum.cal_own, {id: "300", name: SMMFeatEnum.cal_own, module: SMMModule.CALENDAR});
    permissionMap.set(SMMFeatEnum.cal_oth_r, {id: "301", name: SMMFeatEnum.cal_oth_r, module: SMMModule.CALENDAR});
    permissionMap.set(SMMFeatEnum.cal_oth_w, {id: "302", name: SMMFeatEnum.cal_oth_w, module: SMMModule.CALENDAR});
    permissionMap.set(SMMFeatEnum.med_doc_stoma, {id: "400", name: SMMFeatEnum.med_doc_stoma, module: SMMModule.MEDICAL});
    permissionMap.set(SMMFeatEnum.med_plan_stoma, {id: "401", name: SMMFeatEnum.med_plan_stoma, module: SMMModule.MEDICAL});
    permissionMap.set(SMMFeatEnum.doc_fill, {id: "500", name: SMMFeatEnum.doc_fill, module: SMMModule.DOCUMMENTS});
    permissionMap.set(SMMFeatEnum.doc_trigger, {id: "501", name: SMMFeatEnum.doc_trigger, module: SMMModule.DOCUMMENTS});
    permissionMap.set(SMMFeatEnum.bus_xray, {id: "600", name: SMMFeatEnum.bus_xray, module: SMMModule.BUSINESS_XRAY});
    permissionMap.set(SMMFeatEnum.ster, {id: "700", name: SMMFeatEnum.ster, module: SMMModule.STERILIZATION});
    permissionMap.set(SMMFeatEnum.mid_xray, {id: "800", name: SMMFeatEnum.mid_xray, module: SMMModule.MEDIA});
    permissionMap.set(SMMFeatEnum.mid_picture, {id: "801", name: SMMFeatEnum.mid_picture, module: SMMModule.MEDIA});
    permissionMap.set(SMMFeatEnum.mid_bef_aft, {id: "802", name: SMMFeatEnum.mid_bef_aft, module: SMMModule.MEDIA});
    permissionMap.set(SMMFeatEnum.mid_video, {id: "803", name: SMMFeatEnum.mid_video, module: SMMModule.MEDIA});

    permissionMap.set(SMMFeatEnum.recall_view_clinic, {id: "A00", name: SMMFeatEnum.recall_view_clinic, module: SMMModule.RECALL});
    permissionMap.set(SMMFeatEnum.recall_view_patient, {id: "A01", name: SMMFeatEnum.recall_view_patient, module: SMMModule.RECALL});
    permissionMap.set(SMMFeatEnum.recall_process, {id: "A02", name: SMMFeatEnum.recall_process, module: SMMModule.RECALL});

    permissionMap.set(SMMFeatEnum.financial_view_clinic, {id: "B00", name: SMMFeatEnum.financial_view_clinic, module: SMMModule.FINANCIAL});
    permissionMap.set(SMMFeatEnum.financial_view_patient, {id: "B01", name: SMMFeatEnum.financial_view_patient, module: SMMModule.FINANCIAL});
    permissionMap.set(SMMFeatEnum.financial_process, {id: "B02", name: SMMFeatEnum.financial_process, module: SMMModule.FINANCIAL});

    return permissionMap;
}
export function getPermissionById(id: string): Permission | undefined {
    const permissionMap = getPermissionMap();
    return Array.from(permissionMap.values()).find(permission => permission.id === id);
}

export interface RoleGroup{
    id: string;
    value: number;
    name: CognitoPermissions ;
}
